import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Choose your product",
    kicker: "Start with what you need.",
    body: "Choose from stickers on rolls, die-cut stickers and stickers on sheets, or order custom corflute signs and foamboard. Select your preferred size and quantity to find the right option for your project.",
    cta: { label: "Explore Our Products", to: "/" },
  },
  {
    n: "02",
    title: "Customise your order",
    kicker: "Make it yours.",
    body: "Choose your size, quantity and available finishing options. For stickers, choose rolls, die-cut or sheets and upload your own artwork. For signs, select your board size, quantity and whether you need single-sided or double-sided printing. You can also select custom cutting at no additional cost. Our live pricing shows you the price as you configure your order.",
  },
  {
    n: "03",
    title: "Upload your artwork",
    kicker: "Your design. Our production.",
    body: "Upload your print-ready artwork directly through the website. We accept PDF, PNG, JPG, JPEG, SVG, AI and EPS files. Already have your artwork ready? Great — you're ready to go. Need help with your artwork? Contact our team and we'll discuss what's needed. Artwork setup or redesign work may incur an additional charge, which we'll confirm with you before proceeding.",
  },
  {
    n: "04",
    title: "We print your order",
    kicker: "Made by Kwik Kopy Shellharbour.",
    body: "Once your order and artwork are ready for production, we'll get to work. Your products are produced using professional commercial printing equipment, with your selected specifications followed throughout production. We'll keep the process straightforward so you can get on with running your business.",
    cta: { label: "Start Your Order", to: "/" },
  },
];

export default function HowItWorks() {
  return (
    <div className="App">
      <Header />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-14 pb-10">
        <div className="eyebrow" data-testid="how-eyebrow">How it works</div>
        <h1 className="font-display text-5xl sm:text-6xl font-black mt-3 tracking-tight max-w-3xl">Four simple steps from idea to delivery.</h1>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-12 grid grid-cols-1 md:grid-cols-2 gap-5">
        {STEPS.map((s, idx) => (
          <div key={s.n} className="sf-card p-7 flex flex-col gap-4" data-testid={`how-step-${s.n}`}>
            <div className="flex items-baseline gap-4">
              <div className="font-mono-brand text-xl font-bold" style={{ color: idx % 2 === 0 ? "#E4002B" : "#003DA5" }}>{s.n}</div>
              <h3 className="font-display text-2xl font-extrabold leading-tight">{s.title}</h3>
            </div>
            <div className="font-display text-lg font-bold text-slate-800">{s.kicker}</div>
            <p className="text-slate-600 leading-relaxed">{s.body}</p>
            {s.cta && (
              <div className="pt-2">
                <Link to={s.cta.to} className="btn-primary !py-2.5 !px-5 text-sm" data-testid={`how-cta-${s.n}`}>
                  {s.cta.label} <ArrowRight size={16}/>
                </Link>
              </div>
            )}
          </div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-24 text-center">
        <Link to="/" className="btn-outline inline-flex" data-testid="how-start-order">Start Your Order</Link>
      </section>

      <Footer />
    </div>
  );
}
